import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/** What the receipt reading says while it runs, or when it could not propose anything. */
export function PrefillNotice({ reading }: { readonly reading: 'idle' | 'reading' | 'failed' }) {
  const { t } = useTranslation('expenses');
  if (reading === 'reading') {
    return (
      <p role="status" className="text-sm text-muted-foreground">
        {t('capture.prefill.reading')}
      </p>
    );
  }
  if (reading === 'failed') {
    return (
      <p role="status" className="rounded-lg bg-muted p-3 text-sm">
        {t('capture.prefill.failed')}
      </p>
    );
  }
  return null;
}

/**
 * «Abbiamo ripristinato…»: the form came back from the local copy (U10). Only a new expense loses
 * its chosen document; an edited one keeps the document it already has.
 */
export function RecoveryNotice({
  editing,
  onDismiss,
}: {
  readonly editing: boolean;
  readonly onDismiss: () => void;
}) {
  const { t } = useTranslation('expenses-detail');
  return (
    <p role="status" className="flex items-center gap-2 rounded-lg bg-muted p-3 text-sm">
      <span className="grow">{t(editing ? 'recovery.restoredEdit' : 'recovery.restored')}</span>
      <Button type="button" variant="ghost" size="sm" className="h-11 min-h-11" onClick={onDismiss}>
        {t('recovery.ok')}
      </Button>
    </p>
  );
}

/**
 * Art. 50 of the AI Act: says that an AI proposed the fields, how sure it was, and that the user
 * decides. Shown above the fields when at least one is a proposal.
 */
export function AiNotice({ uncertain }: { readonly uncertain: boolean }) {
  const { t } = useTranslation('expenses-detail');
  return (
    <p className="flex items-start gap-1 text-sm text-muted-foreground">
      <Sparkles aria-hidden="true" className="mt-0.5 size-3.5 shrink-0 text-brand" />
      <span>
        {t('ai.notice')} {uncertain ? t('ai.noticeUncertain') : t('ai.noticeSure')}
      </span>
    </p>
  );
}
